import React from "react";
import ReactDOM from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { METHODOLOGIES } from "../../../../hooks";
import "./AdminSlideMenu.scss";

function Item({ to, icon, label, sub, onClick, disabled }) {
  const { pathname } = useLocation();
  const active = !disabled && (pathname === to || pathname.startsWith(to + "/"));

  if (disabled) {
    return (
      <span className="sm-item sm-item--disabled">
        <span className="sm-item__ico">{icon}</span>
        <span className="sm-item__lbl">
          <b>{label}</b>
          {sub && <small>{sub}</small>}
        </span>
      </span>
    );
  }

  return (
    <Link
      to={to}
      className={`sm-item${active ? " sm-item--active" : ""}`}
      onClick={onClick}
    >
      <span className="sm-item__ico">{icon}</span>
      <span className="sm-item__lbl">
        <b>{label}</b>
        {sub && <small>{sub}</small>}
      </span>
    </Link>
  );
}

function Group({ icon, title, sub, children }) {
  return (
    <div className="sm-group">
      <div className="sm-group__head">
        <span>{icon}</span> {title}
      </div>
      {sub && <div className="sm-group__sub">{sub}</div>}
      {children}
    </div>
  );
}

export function AdminSlideMenu({ open, onClose, methodology }) {
  return ReactDOM.createPortal(
    <>
      <div
        className={`sm-overlay${open ? " sm-overlay--open" : ""}`}
        onClick={onClose}
      />
      <div className={`sm-panel${open ? " sm-panel--open" : ""}`}>
        <div className="sm-head">
          <span className="sm-head__title">Navegación</span>
          <button className="sm-head__close" onClick={onClose}>✕</button>
        </div>

        <div className="sm-body">
          {METHODOLOGIES[methodology] && (
            <div className="sm-meth">
              Metodología: <b>{METHODOLOGIES[methodology].label}</b>
              <Link to="/admin/dd-home" onClick={onClose}>Cambiar</Link>
            </div>
          )}

          {/* Evaluación de Diligencia Debida */}
          <Group icon="📋" title="Evaluación de Diligencia Debida" sub="según la metodología de la Guía OCDE 2021">
            <Item to="/admin/ocde-guide"          icon="📘" label="Guía OCDE"            sub="6 etapas paso a paso · citas textuales"       onClick={onClose} />
            <Item to="/admin/ocde-dd-process"     icon="✅" label="Proceso DD · 6 etapas" sub="22 requisitos · estado y evidencia"          onClick={onClose} />
            <Item to="/admin/ocde-risk-register"  icon="⚠️" label="Risk Register · 2.1"  sub="Ejercicio de delimitación de riesgos"          onClick={onClose} />
            <Item to="/admin/self-assessments"    icon="🏢" label="Autoevaluación · 2.2" sub="9 áreas · operaciones propias"                 onClick={onClose} />
            <Item to="/admin/ocde-cap"            icon="🎯" label="CAP Tracker · 3.1"   sub="Planes de acción correctiva"                   onClick={onClose} />
          </Group>

          {/* Recursos normativos */}
          <Group icon="📚" title="Recursos normativos" sub="marco de referencia y plantillas operativas">
            <Item to="/admin/bibliography" icon="📖" label="Bibliografía" sub="12 temas × OCDE · OIT · BW · FLA · ONU" onClick={onClose} />
            <Item to="/admin/repository"   icon="📁" label="Repositorio"  sub="10 plantillas Word descargables"        onClick={onClose} />
          </Group>

          {/* Preparación para auditorías */}
          <Group icon="🔍" title="Preparación para auditorías" sub="mapeo cruzado a estándares de cliente · gestión de políticas">
            <Item to="/admin/audit-map"       icon="🗺️" label="Audit Map"               sub="9 estándares · 96 secciones mapeadas"                 onClick={onClose} />
            <Item to="/admin/policy-tracker"  icon="📊" label="Policy Lifecycle Tracker" sub="20 políticas · estado · vencimientos · archivos"       onClick={onClose} />          </Group>
        </div>
      </div>
    </>,
    document.body
  );
}
